import { defineComponent as o, provide as n, h as u } from "vue";
import { useRtl as l } from "./ghl-ui.es897.js";
import { buttonGroupInjectionKey as i } from "./ghl-ui.es931.js";
import s from "./ghl-ui.es940.js";
import p from "./ghl-ui.es900.js";
import f from "./ghl-ui.es941.js";
const m = {
  size: {
    type: String,
    default: void 0
  },
  vertical: Boolean
}, v = o({
  name: "ButtonGroup",
  props: m,
  setup(t) {
    const {
      mergedClsPrefixRef: e,
      mergedRtlRef: r
    } = p(t);
    return f("-button-group", s, e), n(i, t), {
      rtlEnabled: l("ButtonGroup", r, e),
      mergedClsPrefix: e
    };
  },
  render() {
    const {
      mergedClsPrefix: t
    } = this;
    return u("div", {
      class: [`${t}-button-group`, this.rtlEnabled && `${t}-button-group--rtl`, this.vertical && `${t}-button-group--vertical`],
      role: "group"
    }, this.$slots);
  }
});
export {
  m as buttonGroupProps,
  v as default
};
